document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector('.also-like-list');
  if (!container) return;

  const url = container.dataset.url;
  fetch(url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const newRecommendations = html.querySelector('.also-like-list');

      if (newRecommendations && newRecommendations.innerHTML.trim().length) {
        container.innerHTML = newRecommendations.innerHTML;
      }

       var alsoLikeSwiper = new Swiper(".also-like-list", {
    slidesPerView: 'auto',
    navigation: {
      nextEl: ".also-like-next",
      prevEl: ".also-like-prev",
    },
    pagination: {
      el: ".also-like-list-pagination",
      clickable: true,
    },
  });
    })
    .catch(e => console.error(e));


   
});
